"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
var Status;
(function (Status) {
    Status["OVERDUE"] = "Overdue";
    Status["PARTIALLY_PAID"] = "Partially_Paid";
    Status["UNUSED"] = "Unused";
    Status["APPLIED"] = "Applied";
    Status["UNPAID"] = "Unpaid";
    Status["PAID"] = "Paid";
    Status["PENDING"] = "Pending";
    Status["PROCESSING"] = "Processing";
    Status["CANCELLING"] = "Cancelling";
    Status["CANCELLED"] = "Cancelled";
    Status["AUTOPAY"] = "Autopay";
})(Status = exports.Status || (exports.Status = {}));
